export default __webpack_public_path__ + "static/media/sec-2c.d0f076bb.png";